import { logger } from '@adornis/base/logging.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { Exam } from '../exam.js';

/**
 * Whether this exam's task tree was AUTHORED (the exam-creation tool) rather than uploaded and
 * extracted. `examSource` is the typst source of a created exam — "Absent on uploaded exams" (see
 * `Exam.examSource`) and written only by `compileAndPersistExam` — so its presence is the exam-wide
 * equivalent of `resolveIsStudentOwnedExam`'s student check.
 */
export const isGeneratedExam = (exam: Partial<Pick<Exam, 'examSource'>> | null | undefined): boolean =>
  typeof exam?.examSource === 'string' && exam.examSource.length > 0;

/** Same question for a caller holding only an id — projected, `false` on error, job-safe (no session). */
export async function resolveIsGeneratedExam(examId: string): Promise<boolean> {
  try {
    const examCollection = await getCollection(Exam);
    const exam = await examCollection.findOne({ _id: examId }, { projection: { examSource: 1 } });
    return isGeneratedExam(exam);
  } catch (err) {
    logger.error({ err, examId }, 'Failed to resolve whether exam is generated');
    return false;
  }
}
